import {
  fetchShopDetailShopDetail,
  fetchBizoppDetailShopDetail,
  fetchBizoppBillAccount,
  fetchContractorDetailShopDetail,
  fetchBizoppUpdateTags,
  fetchAllConfig,
  setContractSignType,
  bizoppPickIn,
  getSaleDataByShopId,
  getPromoAmountByShopId,
  getDiDiTopInfoByShopId,
  getNewShopDetail,
  getGrayFlag,
  getDetailButton,
  getEvaluationStatistics,
  getPreSignupList,
  getSpecialCateList,
  getSpecialItemList,
} from '@/api'
import { isEmpty } from 'lodash-es'
export default {
  // 获取商家详情
  getShopDetail({ commit, state }, params) {
    const { shopId, force = false } = params
    const detail = state.shopBaseDetail[shopId]
    if (!force && !isEmpty(detail)) {
      commit('updateCurrentShopDetail', { [shopId]: detail })
      return detail
    }
    return fetchShopDetailShopDetail({
      shopId,
    }).then(res => {
      const detail = { [shopId]: res.data }
      commit('updateShopDetail', detail)
      commit('updateCurrentShopDetail', detail)
      return res.data
    })
  },

  // 获取商机详情
  getBizoppDetail({ commit, state }, params) {
    const { shopId, force = false } = params
    const detail = state.bizoppDetail[shopId]
    if (!force && !isEmpty(detail)) {
      commit('updateCurrentBizoppDetail', { [shopId]: detail })
      return detail
    }
    return fetchBizoppDetailShopDetail({
      shopId,
    }).then(res => {
      const detail = { [shopId]: res.data }
      commit('updateBizoppDetail', detail)
      commit('updateCurrentBizoppDetail', detail)
      commit('updateBizoppType', res.data.type)
      return res.data
    })
  },

  // 获取商机账单信息
  getBizoppBillAccount({ commit, state }, params) {
    const { shopId } = params
    return fetchBizoppBillAccount({
      shopId,
    }).then(res => {
      commit('updateBizoppBillAccount', res.data)
      return res.data
    })
  },
  // 商家信息获取时的经营品类、银行信息、合作平台信息的公共接口
  getAllConfig({ commit, state }, params) {
    const { shopId, locale, withBankList } = params
    const allConfig = state.allConfig[shopId]
    if (!isEmpty(allConfig)) {
      commit('updateCurrentAllConfig', { [shopId]: allConfig })
      return allConfig
    }
    return fetchAllConfig({
      locale,
      withBankList,
    }).then(res => {
      const detail = { [shopId]: res.data }
      commit('updateAllConfig', detail)
      commit('updateCurrentAllConfig', detail)
      return res.data
    })
  },

  // 获取合同详情
  getContractorDetail({ commit, state }, params) {
    const { shopId, contractorId } = params
    const detail = state.contractorDetail[shopId]
    if (!isEmpty(detail)) {
      commit('updateCurrentContractorDetail', { [shopId]: detail })
      return detail
    }
    return fetchContractorDetailShopDetail({
      contractorId,
    }).then(res => {
      const detail = { [shopId]: res.data }
      commit('updateContractorDetail', detail)
      commit('updateCurrentContractorDetail', detail)
      return res.data
    })
  },

  // 选择合同类型
  setContractType({ commit, state }, params) {
    const { shopId, signType } = params
    return setContractSignType({
      shopId,
      signType,
    }).then(res => {
      return res.data
    })
  },

  // 标记问题门店
  bizoppUpdateTags({ commit, state }, params) {
    const { shopId, tags } = params
    return fetchBizoppUpdateTags({
      shopId,
      tags,
    }).then(res => {
      return res.data
    })
  },
  // 捡入商机
  async pickUpBizopp({ commit, state }, params) {
    let res = ''
    try {
      res = await bizoppPickIn({
        ...params,
      })
    } catch (e) {
      console.log(e)
    }
    return res
  },
  // 获取门店涉及销售数据
  async getShopSaleData({ commit, state }, params) {
    let res = {}
    try {
      res = await getSaleDataByShopId({
        ...params,
      })
      commit('updateSaleData', res.data)
    } catch (e) {
      console.log(e)
    }
  },
  // 获取营销活动数量
  async getPromoAmount({ commit, state }, params) {
    const { shopId } = params
    const res = await getPromoAmountByShopId({
      shopId,
    }).then(res => {
      return res.data
    })
    return res
  },
  // 获取优选好店相关信息
  async getDiDiTopInfo({ commit, state }, params) {
    const { shopId } = params
    const res = await getDiDiTopInfoByShopId({
      shopId,
    }).then(res => {
      return res.data
    })
    return res
  },
  // 获取商家详情  商家详情切换成feidian
  async getBusinessDetail({ commit, state }, params) {
    const { shopId, force = false } = params
    const detail = state.shopBaseDetail[shopId]
    if (!force && !isEmpty(detail)) {
      commit('updateCurrentShopDetail', { [shopId]: detail })
      return detail
    }
    // feidian的详情接口没有button对象,所以本期直接获取新的button接口插入
    const button = await getDetailButton({ shopId })
    return getNewShopDetail({
      shopId,
    }).then(res => {
      const shop = {
        ...res.data,
        button: button.data,
      }
      const detail = { [shopId]: shop }
      commit('updateShopDetail', detail)
      commit('updateCurrentShopDetail', detail)
      return shop
    })
  },
  // 获取商家详情给合同用  商家详情切换成feidian
  async getBusinessDetailForContractor({ commit, state }, params) {
    const { shopId } = params
    const res = await getNewShopDetail({
      shopId,
    }).then(res => {
      const shop = {
        ...res.data,
      }
      const detail = { [shopId]: shop }
      commit('updateShopDetail', detail)
      return res.data
    })
    return res
  },
  // 获取灰度标识
  async getOpenGray({ commit, state }, params) {
    const { checkApi } = params
    const res = await getGrayFlag({
      checkApi,
    }).then(res => {
      return res.data
    })
    return res
  },
  // 获取商家评论统计
  async getEvaluation({ commit, state }, params) {
    const { shopId } = params
    const res = await getEvaluationStatistics({
      shopId,
    }).then(res => {
      return res.data
    })
    return res
  },
  // 营销-招商活动预报名topic列表
  async getPreSignupList({ commit, state }, params) {
    const { shopId } = params
    const res = await getPreSignupList({
      shopId,
    }).then(res => {
      commit('updatePreSignupList', res.data)
      return res.data
    })
    return res
  },
  // 营销-招商活动预报名topic-特价菜分类列表
  async getSpecialCateList({ commit, state }, params) {
    const { shopId } = params
    const res = await getSpecialCateList({
      shopId,
    }).then(res => {
      commit('updateItemOptionTotal', res.data.total)
      return res.data
    })
    return res
  },
  // 营销-招商活动预报名topic-特价菜选中菜品
  async getAllSelectItemList({ commit, state }, params) {
    const { shopId } = params
    // 获取所有选中的菜品
    const res = await getSpecialItemList({
      shopId,
      cateId: 1,
    }).then(res => {
      commit('updateAllSelectItems', res.data.list || [])
      commit('updateConfirmSelectItems', res.data.list || [])
    })
    return res
  },
  // 营销-招商活动预报名topic-特价菜菜品列表
  async getSpecialItemList({ commit, state }, params) {
    // 获取当前tab的菜品
    const res = await getSpecialItemList({
      ...params,
    }).then(res => {
      commit('updateSpecialItemList', res.data)
      return res.data
    })
    return res
  },
}
